/**
 * Spanish labels for the prescription statuses defined by the backend model
 * (draft, active, archived, deleted, cancelled).
 */
export const PRESCRIPTION_STATUS_LABELS = {
  draft: 'Borrador',
  active: 'Activa',
  archived: 'Archivada',
  cancelled: 'Cancelada',
  deleted: 'Eliminada'
};

/**
 * Resolves a prescription status to its label.
 *
 * This lives in one place because each screen used to inline its own ternary
 * chain and they drifted: the edit screen only handled 'active' and
 * 'archived', so drafts fell through to the final branch and were shown as
 * "Eliminada" — alarming, and wrong.
 *
 * @param {string} status - Prescription status
 * @returns {string} Label to display
 */
export const getPrescriptionStatusLabel = (status) => (
  PRESCRIPTION_STATUS_LABELS[status] || 'Desconocida'
);
